import {
  AtsQuestionFragment,
  GetQuestionsDocument,
  GetQuestionsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type AtsQuestion = AtsQuestionFragment

export const useQuestions = (variables?: GetQuestionsQueryVariables) => {
  const { data, loading } = useQuery(GetQuestionsDocument, {
    variables,
  })

  return {
    loading,
    questions: data ? (data.ats.questionsConnection.nodes as AtsQuestion[]) : [],
  }
}
